import { mutationTypes } from '@/core/constants'
import { FiltroUtils } from '@/core/utils'

export default {
	[mutationTypes.CONFIGURACAO.TIPO_MODELO_DOCUMENTO.RESET_FILTRO](state) {
		FiltroUtils.limparFiltro(state.filtro)
	},
	[mutationTypes.CONFIGURACAO.TIPO_MODELO_DOCUMENTO.SET_FILTRO_LISTAGEM](state, filtro) {
		FiltroUtils.setarFiltro(state.filtroListagem, filtro)
	},
	[mutationTypes.CONFIGURACAO.TIPO_MODELO_DOCUMENTO.RESET_FILTRO_LISTAGEM](state) {
		FiltroUtils.limparFiltroAvancado(state.filtroListagem)
	},
	[mutationTypes.CONFIGURACAO.TIPO_MODELO_DOCUMENTO.SET_PAGINACAO_LISTAGEM](state, paginacao) {
		state.paginacaoListagem = paginacao
	},
	[mutationTypes.CONFIGURACAO.TIPO_MODELO_DOCUMENTO.RESET_PAGINACAO_LISTAGEM](state) {
		state.paginacaoListagem.page = 1
	},
}
